import { ExternallyVerifiedHealthInformationProto } from "@noom/noom-contracts/noom_contracts/usermodel/baselined/health/external/externally_verified_health_information";
import { Api } from "@noom/noomscape";

import { getAutologinData } from "@/utils/cookies";
import { captureMessage } from "@/utils/sentry";

import { useGoto } from "./useGoto";

export const useMedicalHistory = () => {
  const goto = useGoto();

  const getMedicalHistory = async (): Promise<
    ExternallyVerifiedHealthInformationProto | undefined
  > => {
    const autologinData = getAutologinData();

    if (!autologinData) {
      captureMessage("No autologin data provided for getting medical history");
      goto.error();
      return undefined;
    }

    const { accessCode, accessToken } = autologinData;

    const { verifiedHealthInformation } = await Api.call(
      "healthRecords.getMedicalHistory",
      Api.api.healthRecords.getMedicalHistory,
      { accessCode, accessToken },
    );

    return verifiedHealthInformation;
  };

  const saveMedicalHistory = async (
    healthInformation: ExternallyVerifiedHealthInformationProto,
  ): Promise<void> => {
    const autologinData = getAutologinData();

    if (!autologinData) {
      captureMessage("No autologin data provided for saving medical history");
      goto.error();
      return;
    }

    const { accessCode, accessToken } = autologinData;

    await Api.call(
      "healthRecords.saveMedicalHistory",
      Api.api.healthRecords.saveMedicalHistory,
      {
        accessCode,
        accessToken,
        body: { healthInformation },
      },
    );
  };

  return { getMedicalHistory, saveMedicalHistory };
};
